interface WebhookDomainFlags {
  subscriptions?: boolean;
  order?: boolean;
  charge?: boolean;
  version?: string;
}

export const buildWebhookDomains = ({
  subscriptions,
  order,
  charge,
  version,
}: WebhookDomainFlags): string[] => {
  const domains = [
    subscriptions ? "SUBSCRIPTION" : null,
    order ? "ORDER" : null,
    charge && version === "2.0" ? "CHARGE" : null,
  ];
  return domains.filter((domain): domain is string => domain !== null);
};
